<template>
  <crud-layout
    :title="title"
    :subtitle="subtitle"
    :add-button="true"
    @add="create"
  >
    <template v-slot:list>
      <proveedor-list
        ref="list"
        @update="update"
        @delete="remove"
        @show="show"
      />
    </template>

    <proveedor-create
      v-if="creating"
      :open="creating"
      v-on:itemCreated="onItemCreated"
      v-on:close="creating = false"
    />

    <proveedor-update
      v-if="updating"
      :open="updating"
      :item="itemToEdit"
      v-on:itemUpdated="onItemUpdated"
      v-on:close="updating = false"
    />

    <proveedor-show
      v-if="showing"
      :open="showing"
      :item="itemToShow"
      v-on:close="showing = false"
    />

    <snackbar v-model="flash" />
  </crud-layout>
</template>

<script>
import ProveedorCreate from "../ProveedorCreate";
import ProveedorUpdate from "../ProveedorUpdate";
import ProveedorShow from "../ProveedorShow";
import ProveedorList from "../ProveedorList";

import { CrudLayout, Snackbar } from "@dracul/common-frontend";

export default {
  name: "ProveedorCrud",
  components: {
    CrudLayout,
    Snackbar,
    ProveedorCreate,
    ProveedorUpdate,
    ProveedorShow,
    ProveedorList,
  },
  data() {
    return {
      title: "proveedor.title",
      subtitle: "proveedor.subtitle",
      flash: null,
      creating: false,
      updating: false,
      showing: false,
      itemToEdit: null,
      itemToShow: null,
    };
  },
  methods: {
    onItemCreated() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.created");
    },
    onItemUpdated() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.updated");
    },
    create() {
      this.creating = true;
    },
    update(item) {
      this.updating = true;
      this.itemToEdit = item;
    },
    show(item) {
      this.showing = true;
      this.itemToShow = item;
    },
    remove() {
      // Delete opcional como Marca
    },
  },
};
</script>
